import React from 'react';
// components
import AdditionalChargeForm from '../../forms/AdditionalChargeForm';
import Modal from 'shared/modals/Modal';

const AdditionalChargeModal = ({
  onClose,
  values,
  initialValues,
  isSubmitting,
  setSubmitting
}) => {
  return (
    <Modal isOpen={true} title={`${initialValues && initialValues.id ? 'Edit' : 'Add'} Additional Charge`} handleClose={onClose} containerStyle='medium'>
      <section className={`additiona-charge-form ${isSubmitting ? 'hide-overflow' : ''}`}>
        <AdditionalChargeForm data={initialValues} onClose={onClose} setSubmitting={setSubmitting} />
      </section>
    </Modal>
  );
};

export default AdditionalChargeModal;
